import { range } from "lodash";
export default range(16).map(current => {
  const field = `switch_dip_${current + 1}`;
  return {
    field,
    label: field,
    width: "4%",
    isSortable: false,
    isCSV: true
  };
});
